import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'vectronic-filter-header',
  templateUrl: './filter-header.component.html',
  styleUrls: ['./filter-header.component.scss'],
  imports: [CommonModule, MatDialogModule, MatSlideToggleModule, MatIconModule, MatTooltipModule],
})
export class FilterHeaderComponent {
  isFilterEnabled = input(false);
  title = input<string>();
  icon = input<string>();
  svgIcon = input<string>();
  showToggle = input(true);
  showLine = input(true);
  disabled = input(false);
  titleTooltip = input('');

  enabledFilterToggle = output<boolean>();
  titleClicked = output();

  titleClickHandler() {
    if (this.disabled()) return;

    this.titleClicked.emit();
  }

  toggleChangeHandler($event: { checked: boolean }) {
    if (this.disabled()) return;

    this.enabledFilterToggle.emit($event.checked);
  }
}
